import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms"

export function emailValidator() : ValidatorFn {
    return (control:AbstractControl<string>) : ValidationErrors | null => {
      const value = control.value
  
      if(value && !value.length) {
        return { isEmpty : true }
      } else {
        // the string is an email
        const emailPattern = "^[a-zA-Z_\\-\\.0-9]+@[a-zA-Z_\\-0-9]+?\\.[a-zA-Z]{2,3}$"; 
        if(value && value.match(emailPattern)){
          return null
        }
  
        return { invalid : true }
      }
    }
  }